import { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
    title: ReactNode;
}>

export const ProjectSelectionDeviceList = ({ title, children }: Props) => (
    <div className="vss-project-selection-device-list">
        <div className="vss-project-selection-device-list__header">
            {title}
        </div>

        <div className="vss-project-selection-device-list__list">
            {children}
        </div>
    </div>
);
